import gql from 'graphql-tag'
import client from '@stores/apollo'
import { SpaceTypeFragment } from '@api/fragments'
import { ISpaceType } from '@api/types'
import { InteractivityType } from './'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createSpaceType: { spaceType: ISpaceType }
}

const mutateHandler = handleFetchResult<IPayload, ISpaceType>({
  handler: (data) => data.createSpaceType.spaceType,
  name: 'Space Type',
})

export default function create(name: string, interactivity: InteractivityType) {
  return client.gql
    .mutate({
      mutation,
      variables: {
        input: { displayName: name, interactivity },
      },
    })
    .then(mutateHandler)
}

const mutation = gql`
  mutation createSpaceType($input: CreateSpaceTypeInput!) {
    createSpaceType(input: $input) {
      spaceType {
        ...SpaceTypeFragment
        company {
          id
        }
      }
    }
  }
  ${SpaceTypeFragment}
`
